import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovataxiservicee() {



const cardData = {
keyword: "Innova Taxi Service in Pune",
headingDescription: "Innova Taxi Service in Pune offers a spacious and comfortable travel option for families, groups, corporate travelers, tourists, wedding guests, and passengers requiring reliable local or outstation transportation. With a 7-seater configuration, air-conditioned cabin, generous luggage space, and professional driver support, an Innova taxi can be arranged for airport transfers, local sightseeing, one-day travel, family functions, business requirements, and long-distance journeys. From convenient city transportation to trips from Pune toward Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, and Goa, private Innova taxi service provides flexibility for different passenger and itinerary requirements.",
topPlaces: [
{
title: "Kharadi",
description: "Kharadi is one of Pune's prominent technology and commercial hubs, with corporate offices, residential communities, hotels, and business parks. An Innova taxi from Kharadi is suitable for corporate transportation, airport transfers, family travel, group journeys, and outstation trips where passengers need comfortable seating and useful luggage capacity."
},
{
title: "Hinjewadi",
description: "Hinjewadi is a major IT and business destination attracting employees, executives, clients, and visitors throughout the year. Innova taxi services are convenient for office transfers, business meetings, airport connections, corporate events, and intercity travel, particularly when several passengers need to travel together."
},
{
title: "Koregaon Park",
description: "Koregaon Park is known for its hotels, restaurants, residential properties, and business establishments, making it a frequent destination for visitors and professionals. A private Innova taxi can provide comfortable transportation from the area for airport transfers, events, sightseeing, family travel, and longer journeys outside Pune."
},
{
title: "Hadapsar",
description: "Hadapsar is a busy residential and commercial locality with important business centers, offices, and connectivity toward several parts of Pune. An Innova taxi is a practical choice for families, employees, business travelers, and groups requiring airport transportation, local travel, event transfers, or outstation journeys."
},
{
title: "Pune Airport",
description: "Pune Airport is a key transportation point for passengers arriving in and departing from the city. A 7-seater Innova taxi provides useful space for families and groups with luggage, making airport pickup and drop arrangements convenient for travel to hotels, homes, offices, railway stations, and onward destinations."
},
{
title: "Lonavala",
description: "Lonavala is a popular weekend destination from Pune for families, friends, corporate groups, and tourists. An Innova taxi provides a comfortable private travel option for groups carrying luggage and planning sightseeing around the hill station, with the convenience of traveling together in one spacious vehicle."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar attracts tourists throughout the year for its pleasant hill-station environment, viewpoints, attractions, and family-friendly destinations. Innova taxi service from Pune is suitable for groups and families seeking private transportation with comfortable seating, air conditioning, and adequate room for luggage."
},
{
title: "Nashik",
description: "Nashik is an important destination for tourism, business travel, religious visits, and family trips from Pune. A spacious Innova taxi can make the longer road journey more convenient by allowing passengers to travel together with their luggage while enjoying a private driver-operated vehicle."
},
{
title: "Shirdi",
description: "Shirdi is a major pilgrimage destination visited by families, devotees, and groups from Pune and surrounding areas. An Innova taxi provides direct private transportation with enough seating for multiple passengers and luggage, making the journey convenient for both onward travel and planned return trips."
},
{
title: "Goa",
description: "Goa is a popular long-distance destination for holidays, group vacations, family trips, weddings, and leisure travel from Pune. An Innova taxi is well suited to such journeys because its spacious cabin, air conditioning, seating capacity, and luggage space provide a practical environment for passengers traveling together."
}
],
services: [
{
name: "Innova Taxi Pune",
description: "Innova Taxi Pune provides spacious private transportation for local journeys, airport transfers, family trips, corporate travel, sightseeing, and outstation routes. The 7-seater cabin, air conditioning, and luggage capacity make it suitable for passengers who prefer comfortable travel in a single vehicle."
},
{
name: "Innova Cab Service Pune",
description: "Innova Cab Service Pune offers a convenient travel solution for individuals, families, groups, and business travelers. The service can be arranged for city transfers, airport transportation, events, sightseeing, and longer road journeys while providing the convenience of a private vehicle and professional driver."
},
{
name: "Innova Taxi Booking Pune",
description: "Innova Taxi Booking Pune allows passengers to arrange a spacious taxi according to their travel schedule and passenger requirements. It is useful for airport transfers, local transportation, family outings, business travel, wedding events, sightseeing, and outstation journeys requiring a comfortable 7-seater vehicle."
},
{
name: "Innova Cab Booking Pune",
description: "Innova Cab Booking Pune is suitable for travelers who need a comfortable private vehicle for planned journeys within Pune or to destinations outside the city. With sufficient seating and luggage space, an Innova can accommodate families, groups, corporate teams, and tourists for different travel purposes."
},
{
name: "Innova Taxi on Rent Pune",
description: "Innova Taxi on Rent Pune provides flexible access to a spacious taxi for short-term or full-day travel requirements. Passengers can use the vehicle for sightseeing, family functions, airport transportation, corporate movements, local errands, and outstation trips while keeping their group together."
},
{
name: "Innova Taxi Hire Pune",
description: "Innova Taxi Hire Pune is a practical option for passengers looking for a spacious and comfortable vehicle with driver assistance. It can be arranged for business travel, family holidays, airport transfers, weddings, sightseeing, and intercity journeys where private transportation is preferred."
},
{
name: "Innova Rental Taxi Pune",
description: "Innova Rental Taxi Pune offers a convenient vehicle option for passengers requiring additional seating and luggage space. The rental can support local travel, airport pickups, one-day transportation, family outings, corporate requirements, events, and outstation routes from Pune."
},
{
name: "AC Innova Taxi Pune",
description: "AC Innova Taxi Pune provides an air-conditioned cabin for comfortable transportation across Pune and on longer road journeys. Families, senior passengers, business travelers, and groups can benefit from the spacious interior, climate-controlled environment, and private driver-operated travel arrangement."
},
{
name: "Luxury Innova Taxi Pune",
description: "Luxury Innova Taxi Pune offers a premium private transportation option for passengers who value comfortable interiors and a spacious travel environment. It is suitable for corporate travel, airport transfers, weddings, special occasions, family journeys, and tourism where a more refined taxi experience is desired."
},
{
name: "7 Seater Innova Taxi Pune",
description: "7 Seater Innova Taxi Pune is designed for families and groups who want to travel together in one vehicle. The seating capacity reduces the need for multiple cars, while the spacious cabin and luggage area make it useful for airport transfers, holidays, events, sightseeing, and outstation travel."
},
{
name: "Affordable Innova Taxi Service Pune",
description: "Affordable Innova Taxi Service Pune provides a practical option for travelers who need the additional space of an Innova for their journey. It can be considered for city transportation, airport transfers, family trips, corporate travel, sightseeing, weddings, and outstation routes based on the passenger requirement."
},
{
name: "Innova Outstation Taxi Pune",
description: "Innova Outstation Taxi Pune is suitable for longer private road journeys from Pune to destinations across Maharashtra and neighboring states. Comfortable seating, air conditioning, luggage capacity, and professional driver support make it convenient for families and groups traveling over extended distances."
},
{
name: "Innova Airport Taxi Pune",
description: "Innova Airport Taxi Pune provides spacious transportation for passengers traveling to or from Pune Airport. Families and groups can keep their luggage and passengers together in one vehicle, making airport transfers convenient for travel between the airport, homes, hotels, offices, and other destinations."
},
{
name: "Innova Airport Pickup Pune",
description: "Innova Airport Pickup Pune is useful for travelers arriving at Pune Airport with family members, colleagues, or multiple pieces of luggage. The spacious taxi allows passengers to travel together from the terminal to their destination while avoiding the need to coordinate multiple smaller vehicles."
},
{
name: "Innova for Family Travel Pune",
description: "Innova for Family Travel Pune provides a comfortable private vehicle for holidays, weekend trips, religious visits, family gatherings, and long-distance journeys. Families can travel together with adequate luggage space and enjoy the flexibility of arranging direct pickup and drop according to their itinerary."
},
{
name: "Innova for Group Travel Pune",
description: "Innova for Group Travel Pune allows friends, relatives, colleagues, and small groups to share a spacious vehicle throughout their journey. It is useful for airport transfers, corporate outings, sightseeing, weekend trips, events, and outstation travel where coordinated transportation is important."
},
{
name: "Innova Corporate Taxi Pune",
description: "Innova Corporate Taxi Pune offers comfortable transportation for employees, executives, clients, and business teams. It can be used for airport transfers, office movements, meetings, conferences, site visits, corporate events, and intercity business travel requiring a spacious private vehicle."
},
{
name: "Innova Wedding Taxi Pune",
description: "Innova Wedding Taxi Pune is suitable for transporting wedding guests, relatives, family members, and event participants between airports, railway stations, hotels, homes, and venues. Its spacious seating makes group movement easier during weddings and other special occasions."
},
{
name: "Innova Local Sightseeing Pune",
description: "Innova Local Sightseeing Pune provides private transportation for families and groups exploring Pune's historical, cultural, religious, and recreational attractions. Travelers can organize multiple stops according to their schedule while keeping the same spacious vehicle and driver throughout the sightseeing plan."
},
{
name: "Innova Taxi Near Me Pune",
description: "Innova Taxi Near Me Pune helps travelers searching for a spacious private taxi close to their pickup location. The service can be used for local transfers, airport journeys, family travel, corporate transportation, sightseeing, events, and outstation trips from different parts of Pune."
},
{
name: "Innova One Day Taxi Rental Pune",
description: "Innova One Day Taxi Rental Pune is convenient for full-day travel plans involving multiple destinations, meetings, shopping, sightseeing, family activities, or events. A dedicated taxi and driver provide greater flexibility to follow the day's itinerary without repeatedly arranging separate transportation."
},
{
name: "Innova Taxi with Driver Pune",
description: "Innova Taxi with Driver Pune provides chauffeur-assisted transportation for passengers who prefer to relax or focus on their activities instead of driving. It is suitable for airport transfers, family trips, business travel, weddings, sightseeing, and long-distance road journeys."
},
{
name: "Private Innova Taxi Pune",
description: "Private Innova Taxi Pune provides exclusive vehicle use for individuals, families, and groups without sharing the cabin with unrelated passengers. This arrangement offers privacy and scheduling flexibility for airport travel, business requirements, family functions, sightseeing, holidays, and outstation journeys."
},
{
name: "Innova Tourist Taxi Pune",
description: "Innova Tourist Taxi Pune is suitable for travelers visiting Pune attractions or planning trips to nearby and long-distance tourist destinations. The spacious cabin, air conditioning, luggage capacity, and driver support make it convenient for customized sightseeing programs and family or group vacations."
},
{
name: "Innova Round Trip Taxi Pune",
description: "Innova Round Trip Taxi Pune is useful for passengers planning a return journey between Pune and another destination. The private vehicle arrangement can simplify both onward and return transportation for family trips, religious visits, sightseeing, business travel, and other planned intercity journeys."
}
],
tableData: [
["Innova Taxi Pune"],
["Innova Cab Service Pune"],
["Innova Taxi Booking Pune"],
["Innova Cab Booking Pune"],
["Innova Taxi on Rent Pune"],
["Innova Taxi Hire Pune"],
["Innova Rental Taxi Pune"],
["AC Innova Taxi Pune"],
["Luxury Innova Taxi Pune"],
["7 Seater Innova Taxi Pune"],
["Affordable Innova Taxi Service Pune"],
["Innova Outstation Taxi Pune"],
["Innova Airport Taxi Pune"],
["Innova Airport Pickup Pune"],
["Innova for Family Travel Pune"],
["Innova for Group Travel Pune"],
["Innova Corporate Taxi Pune"],
["Innova Wedding Taxi Pune"],
["Innova Local Sightseeing Pune"],
["Innova Taxi Near Me Pune"],
["Innova One Day Taxi Rental Pune"],
["Innova Taxi with Driver Pune"],
["Private Innova Taxi Pune"],
["Innova Tourist Taxi Pune"],
["Innova Round Trip Taxi Pune"]
],
whychoose: [
{
WhyChooseheading: "Spacious 7-Seater Cabin",
WhyChoosedescription: "The Innova provides useful seating space for families and groups traveling together, helping passengers avoid the inconvenience of arranging multiple smaller vehicles. Its practical interior also provides room for luggage during airport transfers, holidays, and longer road journeys."
},
{
WhyChooseheading: "Comfortable Air-Conditioned Travel",
WhyChoosedescription: "An air-conditioned cabin creates a more comfortable environment for passengers during Pune's warm weather and extended journeys. The spacious interior is particularly useful for families, senior travelers, corporate passengers, and groups spending several hours on the road."
},
{
WhyChooseheading: "Private Driver-Assisted Service",
WhyChoosedescription: "Driver-assisted taxi service allows passengers to travel without handling the driving themselves. This can be useful for unfamiliar routes, airport transportation, business schedules, sightseeing plans, family holidays, and long-distance journeys where passengers prefer to relax during travel."
},
{
WhyChooseheading: "Useful for Local and Outstation Trips",
WhyChoosedescription: "The Innova can handle a wide variety of travel requirements, from short city transfers and sightseeing to longer routes outside Pune. Its flexible usage makes it suitable for destinations such as Lonavala, Mahabaleshwar, Nashik, Shirdi, Mumbai, Goa, and other intercity locations."
},
{
WhyChooseheading: "Convenient Airport Transportation",
WhyChoosedescription: "The combination of passenger seating and luggage space makes an Innova practical for airport pickups and drops. Families and groups can travel together between Pune Airport and their homes, hotels, offices, railway stations, or onward destinations."
},
{
WhyChooseheading: "Suitable for Corporate Requirements",
WhyChoosedescription: "Business travelers can use Innova taxis for executive transportation, client pickups, office transfers, conferences, meetings, and site visits. The spacious cabin provides a comfortable setting for employees and visiting professionals traveling together."
},
{
WhyChooseheading: "Ideal for Events and Family Functions",
WhyChoosedescription: "Weddings, family functions, ceremonies, and celebrations often require reliable transportation for guests and relatives. A spacious Innova can help move small groups between venues, hotels, airports, railway stations, and residences according to the event schedule."
},
{
WhyChooseheading: "Flexible Round-Trip Travel",
WhyChoosedescription: "For journeys where passengers need transportation for both onward and return travel, an Innova round-trip arrangement can simplify planning. The same private vehicle can support family holidays, religious trips, sightseeing programs, business travel, and other scheduled intercity journeys."
}
]
};














const faqData = [
{
question: "What is included with an Innova Taxi Service in Pune?",
answer: "An Innova taxi can be arranged for local travel, airport transfers, corporate transportation, family functions, sightseeing, and outstation journeys from Pune. You can share the pickup point, destination, travel date, passenger count, and required duration so Citysky Cabs can plan the taxi arrangement according to your itinerary."
},
{
question: "Can I hire an Innova taxi for local travel in Pune?",
answer: "Local Innova taxi services are suitable for business meetings, shopping trips, family functions, hotel transfers, city travel, and sightseeing within Pune. The vehicle provides a practical option when passengers prefer to travel together instead of arranging multiple smaller cars."
},
{
question: "Is an Innova taxi available for outstation trips from Pune?",
answer: "An Innova taxi can be arranged for journeys from Pune to destinations such as Mumbai, Goa, Nashik, Shirdi, Mahabaleshwar, Kolhapur, Bangalore, Hyderabad, and other cities. Depending on the itinerary, passengers can discuss one-way, round-trip, or multi-day travel requirements."
},
{
question: "Can families use an Innova Taxi Service in Pune?",
answer: "Families can choose an Innova taxi for holidays, religious visits, weddings, family gatherings, weekend trips, and longer journeys. Travelling together in one vehicle makes it easier to coordinate departure times, luggage, children, senior passengers, and planned stops along the route."
},
{
question: "Can I book an Innova taxi for Pune Airport pickup and drop?",
answer: "Pune Airport transfers can be arranged with an Innova for families, business travellers, wedding groups, and passengers carrying multiple bags. Sharing the flight schedule, pickup location, passenger details, and destination helps Citysky Cabs coordinate the airport journey around the required timing."
},
{
question: "Is an Innova taxi suitable for corporate travel in Pune?",
answer: "Corporate travellers can use an Innova taxi for client meetings, conferences, employee transportation, training programs, business visits, office transfers, and team outings. The larger vehicle can be convenient when colleagues or clients need to travel together between multiple locations."
},
{
question: "Can I hire an Innova taxi for weddings and functions in Pune?",
answer: "Wedding families can arrange an Innova taxi for transporting relatives and guests between homes, hotels, marriage halls, reception venues, railway stations, airports, and other function locations. The arrangement can be planned around the event schedule and the number of passengers travelling together."
},
{
question: "Can I use an Innova taxi for a one-day trip from Pune?",
answer: "A one-day Innova taxi journey can be planned for sightseeing, religious visits, nearby destinations, family outings, or weekend travel. Providing the departure point, destination, expected return time, passenger count, and preferred travel schedule helps organize the trip around the planned day's activities."
},
{
question: "Does Citysky Cabs provide Innova taxis for sightseeing?",
answer: "Sightseeing groups can use an Innova taxi when they want to visit multiple attractions while staying together throughout the journey. The service can be considered for Pune sightseeing as well as trips to nearby destinations where the itinerary includes several stops and flexible travel timings."
},
{
question: "How can I book an Innova Taxi Service in Pune with Citysky Cabs?",
answer: "To arrange an Innova taxi, provide your pickup location, destination, travel date, number of passengers, luggage requirements, preferred departure time, and trip duration. Citysky Cabs can then coordinate the taxi service according to your local, airport, corporate, sightseeing, or outstation travel plan."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Sandeep Kulkarni",
feedback:
"I arranged an Innova taxi in Pune for a family event where relatives were arriving at different times. Having a larger vehicle made it easier to manage the airport and hotel transfers without arranging separate cars for everyone. Citysky Cabs understood the schedule and coordinated the transportation accordingly.",
rating: 5
},
{
id: 2,
name: "Miss. Pooja Deshmukh",
feedback:
"Our group needed an Innova for a short trip from Pune with luggage and several sightseeing stops. The booking process with Citysky Cabs was straightforward, and travelling together made the entire itinerary easier to manage. The vehicle arrangement worked well for our group size and travel plans.",
rating: 5
}
];
























    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Taxi Service in Pune",
  "image": "https://www.cityskycab.in/assets/images/innova-taxi-service-in-pune.webp",
  "description": "Innova Taxi Service in Pune from Citysky Cabs is a practical choice for comfortable local travel, airport transfers, business trips, family journeys and outstation routes. The service covers Innova Taxi Pune, Innova Cab Service Pune, taxi booking, cab booking, taxi on rent and Innova Taxi Hire Pune requirements. AC Innova vehicles offer spacious seating and luggage capacity, making them suitable for individuals, families and small groups travelling around Pune or beyond the city. Customers can arrange convenient pickups, choose suitable rental durations and use the service for full-day local travel, airport drops, corporate transportation and intercity journeys with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/innova-taxi-service-in-pune"
  }
};







    return (
        <div>


<Helmet>
  <title>
    Innova Taxi Service in Pune | AC Innova Taxi for Local & Outstation Trips | +91 8554819191
  </title>

  <meta
    name="description"
    content="Get Innova Taxi Service in Pune from Citysky Cabs for local rides, airport transfers, corporate travel and outstation trips. Enjoy AC comfort, spacious seating and experienced drivers with flexible taxi options."
  />

  <meta
    name="keywords"
    content="Innova Taxi Pune, Innova Cab Service Pune, Innova Taxi Booking Pune, Innova Cab Booking Pune, Innova Taxi on Rent Pune, Innova Taxi Hire Pune, Innova Rental Taxi Pune, AC Innova Taxi Pune, Innova Taxi Service in Pune, Innova cab Pune, Innova local taxi Pune, Innova airport taxi Pune, Innova outstation taxi Pune, Innova taxi rental Pune, Innova car hire Pune, 7 seater Innova taxi Pune, Innova AC cab Pune, Innova full day taxi Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/20.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innovataxiservicee;